






















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class AxLayout2 extends Vue {
  @Prop()
  scrollTop!: number;

  async created() {
    await this.$nextTick();

    const element = document.querySelector('#ax-layout .v-content');
    if (element) {
      element.scrollTop = this.scrollTop;
      element.addEventListener('scroll', event => this.$emit('scroll', event));
    }
  }
}
